import React from 'react';
import { UserRound, MapPin, CalendarClock, Building2, AlertTriangle } from 'lucide-react';

const ICONS = { name: UserRound, address: MapPin, age: CalendarClock, facility: Building2 };

/**
 * Masked residual-identifier snippets from detectResidualPHI (client preview) or a 400 PHI_SUSPECTED response.
 * `[{ type, label, snippet }]`
 */
export default function PhiMatchList({ matches = [], className = '', compact = false }) {
  const list = Array.isArray(matches) ? matches.slice(0, 10) : [];
  if (!list.length) return null;
  return (
    <ul className={`space-y-2 ${className}`}>
      {list.map((m, i) => {
        const Icon = ICONS[m.type] || AlertTriangle;
        return (
          <li key={`${m.type}-${i}`} className={`flex items-start gap-2.5 rounded-xl border border-warn/30 bg-warn-soft ${compact ? 'px-2.5 py-1.5' : 'p-3'} text-sm`}>
            <Icon className="mt-0.5 h-4 w-4 shrink-0 text-warn" aria-hidden="true" />
            <span className="min-w-0">
              <span className="block text-[11px] font-bold uppercase tracking-wider text-warn">{m.label || 'Possible identifier'}</span>
              <span className="block break-words font-mono text-xs text-ink">{m.snippet}</span>
            </span>
          </li>
        );
      })}
    </ul>
  );
}
